export default class Menu {

    constructor(node) {

        this.node = node;
        this.ctaOpen = this.node.querySelector('.menu-burger');
        this.ctaClose = document.querySelector('.menu-close');
        this.navigationMobile = document.querySelector('.navigation-main--mobile');
        this.mobileLinks = this.navigationMobile.querySelectorAll('.scroll-to-link');
        this.mobileLinksArray =  Array.from(this.mobileLinks);

        this.toggleMenuAction = this.toggleMenuAction.bind(this);
        this.clickLinkAction = this.clickLinkAction.bind(this);

        this.init();
    }

    init() {
        this.reset();
        this.addListeners();
    }

    addListeners() {

        this.ctaOpen.addEventListener('click', this.toggleMenuAction);
        this.ctaClose.addEventListener('click', this.toggleMenuAction);

        this.mobileLinksArray.forEach(link => {
			link.addEventListener('click', this.clickLinkAction);
		})
    }

    toggleMenuAction(e) {
        e.preventDefault();
        this.navigationMobile.classList.toggle('open');
    }

    clickLinkAction(e) {
	    this.navigationMobile.classList.remove('open');
    }

    reset() {
        this.navigationMobile.classList.remove('open');
    }


    static destroy() {

        this.ctaOpen.removeEventListener('click', this.clickAction);
        this.ctaClose.removeEventListener('click', this.clickAction);

        this.mobileLinksArray.forEach(link => {
			link.removeEventListener('click', this.clickLinkAction);
		})

        this.reset();
    }

    static init() {
        Menu.item = new Menu(document.querySelector('.header'));
    }
}